const _ = require("lodash");
const Font = require("./Font");
const ErrorUtil = require("../../../shared/ErrorUtil");

// These values were found empirically by drawing 600px test in the CanvasMath
// playground in various fonts. The constant coefficient is based on getting
// CanvasMath comparison tests to match. Example, draw the following in the
// playground and make sure their bottoms align:
/**
  ctx.textBaseline = "middle";
  ctx.font = "600px lizzie";
  ctx.fillText("8", 100, 100);
  ctx.textBaseline = "alphabetic";
  ctx.font = "600px lizzie";
  ctx.fillText("8", 120, 100 + 205.5 - 0.5);
**/

const middleShiftCoeffTable = {
	default: 205.5 / 600,
	roboto: 205.5 / 600,
	"roboto slab": 233.5 / 600,
	"sans-serif": 207.5 / 600,
	lora: 228.5 / 600,
	lizzie: 205.5 / 600,
};
const middleShiftConst = -0.5;

const clean = function(fontFamily) {
	return fontFamily.toLowerCase().replace(/[\"\']/g, "");
};

const getMiddleTextShift = function(font) {
	const fontInfo = Font.toInfo(font);
	if (!_.isArray(fontInfo.family)) {
		ErrorUtil.log(
			"E_FONT_FAMILY_NOT_ARRAY",
			'Called getMiddleTextShift with font "' +
				font +
				'" and got fontInfo with family not a string.',
			{font, fontInfo}
		);
		fontInfo.family = [fontInfo.family];
	}
	const coeff =
		_.find(fontInfo.family.map(f => middleShiftCoeffTable[clean(f)])) ||
		middleShiftCoeffTable.default;
	const fontSize = Font.toInfo(font).size;
	return coeff * fontSize + middleShiftConst;
};

// drawMiddleText but using the provided font instead of the context's current.
const drawMiddleTextForFont = function(ctx, font, text, x, y, stroke = false) {
	let yShift = 0;
	if (ctx.textBaseline === "alphabetic") {
		yShift = getMiddleTextShift(font);
	} else if (ctx.textBaseline !== "middle") {
		ErrorUtil.log(
			"E_CANVAS_TEXT",
			"Called drawMiddleText with textBaseline " +
				ctx.textBaseline +
				" which is not alphabetic or middle"
		);
	}
	ctx.fillText(text, x, y + yShift);
	if (stroke) {
		ctx.strokeText(text, x, y + yShift);
	}
};

// Helper for converting old fillText calls using textBaseline middle to
// an equivalent textBaseline alphabetic call.
const drawMiddleText = function(ctx, text, x, y, stroke = false) {
	return drawMiddleTextForFont(ctx, ctx.font, text, x, y, stroke);
};

module.exports = {
	getMiddleTextShift,
	drawMiddleTextForFont,
	drawMiddleText,
};
